const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdaySign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238.667,
    height: 149.749,
    viewBox: "0 0 63.147 39.621",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.291-.534.602-1.046.854-1.585.478-1.015.03-1.868-1.055-1.927a34.001 34.001 0 0 0-3.612-.023c-5.433.286-10.625-.754-15.706-2.623-4.535-1.669-8.892-3.702-13.156-5.964a70.504 70.504 0 0 0-4.274-2.058c-.301-.133-.747-.095-1.072.019-.463.163-.671.942-.366 1.362.44.605.918 1.193 1.449 1.717 2.274 2.239 4.925 3.962 7.702 5.493 4.174 2.303 8.567 4.12 13.179 5.299C-12.111.719-8.079 1.27-3.975.87-2.619.738-1.294.514 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.37661 -.18341 -.18341 -.37661 31.352 -.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.127-3.064-.048-6.124-.208-9.182-.098-1.853-.295-3.701-.427-5.553-.047-.654-.03-1.312-.047-1.968-.01-.446.076-.828.377-1.209.331-.419.227-.821-.218-1.098a7.766 7.766 0 0 0-1.32-.64c-2.915-1.127-5.942-1.849-9.007-2.415a190.89 190.89 0 0 0-5.977-.995c-1.133-.172-2.277-.282-3.418-.394-1.85-.183-3.701-.338-5.55-.515-2.121-.202-4.239-.428-6.361-.621-2.177-.196-4.357-.37-6.536-.54-.38-.03-.772-.04-1.146.018-1.12.174-1.65 1.091-1.284 2.178.266.788.718 1.477 1.19 2.146 1.674 2.367 3.42 4.68 5.25 6.93a317.723 317.723 0 0 1 3.476 4.362c.337.429.634.892.918 1.358.323.531.3.764-.137 1.143-.411.357-.838.71-1.301.995-3.209 1.98-6.342 4.089-9.753 5.727-.641.307-1.288.608-1.823 1.093-.976.886-.882 1.857.291 2.506.522.289 1.098.489 1.663.688 2.682.945 5.419 1.706 8.172 2.4 3.335.842 6.679 1.654 10.042 2.371 2.348.5 4.731.844 7.105 1.212 2.373.369 4.753.703 7.135 1.013 1.517.197 3.042.323 4.564.478 1.839.188 3.268-.624 3.668-2.68.272-1.397.56-2.787.591-4.213C-.039 3.063-.023 1.532 0 0",
    style: {
      fill: "#fe6b75",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.31717 -.15446 -.15446 -.31717 14.3 25.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.133-.032-4.268-.124-6.399-.078-1.91.041-3.815.225-5.721.397-2.451.222-4.89.527-7.306.971-2.63.483-5.243 1.065-7.851 1.66-.792.181-1.563.501-2.303.843-.857.396-1.339 1.094-1.346 2.079-.006.876.011 1.739.224 2.605.77 3.129 1.457 6.277 2.025 9.453.474 2.647.654 5.313.781 7.987.067 1.426.187 2.841.606 4.208a8.89 8.89 0 0 0 .758 1.808c.697 1.21 2.112 1.897 3.363 1.383 1.414-.582 2.882-.612 4.329-.779a554.91 554.91 0 0 0 13.649-1.743c4.815-.675 9.59-1.565 14.361-2.494.586-.114 1.183-.254 1.726-.491 1.017-.443 1.251-1.392.617-2.291-.382-.542-.899-.952-1.417-1.357C6.212 21.13 2.234 18.238-2.057 15.8a8.09 8.09 0 0 1-.688-.447c-.35-.249-.391-.468-.107-.814.346-.422.698-.849 1.099-1.215 3.596-3.282 7.226-6.525 11.12-9.456a8.15 8.15 0 0 0 1.106-.975c.644-.699.534-1.588-.253-2.106a2.978 2.978 0 0 0-.9-.378C8.418.184 7.503.034 6.565.024 4.378.001 2.189-.039.001-.072L0 0",
    style: {
      fill: "#fe6b75",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.31717 -.15446 -.15446 -.31717 59.946 13.096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.003-.93 0-1.86.021-2.79.088-3.719.181-7.438.283-11.155.013-.491.056-.986.145-1.468.195-1.064.736-1.524 1.832-1.421.809.076 1.626.25 2.396.511 4.035 1.369 8.059 2.772 12.081 4.183.668.235 1.328.517 1.947.86 1.482.82 1.718 1.836.724 3.236a9.862 9.862 0 0 1-1.543 1.691c-2.617 2.28-5.494 4.157-8.755 5.392C6.365.086 3.503.77.582 1.286.04.877-.002.445 0 0m-120.855-6.42c.453.8 1.153 1.128 1.817 1.487 3.899 2.108 7.951 3.852 12.223 5.067 2.257.641 4.516 1.276 6.844 1.612.536.077 1.091.167 1.623.112 1.074-.11 1.668-.843 1.565-1.914-.068-.702-.233-1.398-.387-2.09-.872-3.886-1.751-7.772-2.637-11.656-.121-.53-.248-1.068-.457-1.568-.367-.876-.996-1.28-1.943-1.164a6.295 6.295 0 0 0-1.868.544 93.823 93.823 0 0 0-4.696 2.32 836.752 836.752 0 0 0-9.491 5.169c-.667.368-1.308.793-1.919 1.248-.28.209-.458.557-.674.833",
    style: {
      fill: "#fd8080",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.31717 -.15446 -.15446 -.31717 46.462 10.66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.612-.943-.628-.944-.567-1.861.08-1.202.281-2.401.267-3.599a990.373 990.373 0 0 0-.274-14.107c-.052-2.022-.186-4.042-.306-6.062-.087-1.474-.2-2.946-.325-4.417a4.94 4.94 0 0 0-.237-1.118c-.197-.603-.754-.827-1.307-.493a9.1 9.1 0 0 0-1.307.986 16.879 16.879 0 0 1-4.095 2.678c-4.161 1.938-8.266 3.993-12.59 5.562a115.748 115.748 0 0 1-17.662 4.861c-3.214.617-6.437 1.202-9.672 1.696-2.155.33-4.337.501-6.512.697-1.959.177-3.923.292-5.885.434-.272.019-.546.044-.819.048-4.048.05-8.096.174-12.143.124-3.224-.04-6.453-.217-9.668-.474-2.938-.235-5.858-.69-8.792-.994-4.131-.428-8.221-1.135-12.289-1.943a135.332 135.332 0 0 1-19.85-5.557c-4.569-1.659-9.12-3.362-13.561-5.346-.844-.378-1.737-.673-2.389-1.387a1.173 1.173 0 0 0-.408-.268 1.067 1.067 0 0 0-1.498.809c-.068.374-.082.76-.093 1.143-.058 1.914-.162 3.828-.15 5.742.044 7.113.132 14.224.183 21.336.005.578-.149 1.157-.234 1.778.319.582.959.81 1.526 1.12 3.653 1.99 7.486 3.581 11.35 5.104 7.077 2.791 14.355 4.911 21.787 6.486 3.683.779 7.379 1.509 11.126 1.947 2.604.304 5.195.719 7.802.987 2.282.236 4.577.378 6.87.489 5.522.269 11.047.322 16.575.277 2.736-.023 5.459-.206 8.18-.465 2.337-.223 4.682-.385 7.011-.675a166.67 166.67 0 0 0 8.26-1.218c5.376-.945 10.727-2.02 15.958-3.612 7.054-2.147 14.077-4.389 20.768-7.537a71.667 71.667 0 0 0 3.505-1.787C-.895 1.076-.301.757 0 0",
    style: {
      fill: "#ff8e75",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.31717 -.15446 -.15446 -.31717 49.741 .24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.757 132.678q0 .248-.088.46-.085.21-.24.366-.193.193-.456.29-.263.096-.664.096h-.496v1.39h-.496v-3.73h1.012q.335 0 .568.058.233.055.414.175.213.143.328.356.118.213.118.539zm-.516.012q0-.193-.068-.336-.068-.142-.205-.233-.12-.077-.276-.11-.153-.035-.388-.035h-.491v1.49h.418q.3 0 .489-.052.187-.055.305-.173.118-.12.165-.253.05-.133.05-.298z",
    transform: "rotate(-33.74 -147.932 164.365)",
    "aria-label": "P",
    style: {
      fontSize: "5.1299px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.418901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.18 136.909h-.529l-.365-1.04h-1.614l-.365 1.04h-.504l1.358-3.73h.661zm-1.047-1.465-.654-1.831-.656 1.83z",
    transform: "rotate(-35.21 -143.95 155.873)",
    "aria-label": "A",
    style: {
      fontSize: "5.1299px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.418901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.582 132.225h-.644l-1.247-1.483h-.699v1.483h-.496v-3.73h1.045q.338 0 .563.046.226.042.406.155.203.128.316.323.115.193.115.491 0 .403-.203.676-.203.27-.558.409zm-1.16-2.68q0-.16-.057-.283-.055-.125-.185-.21-.108-.073-.256-.1-.148-.03-.348-.03h-.584v1.407h.501q.236 0 .411-.04.175-.043.298-.155.113-.105.165-.24.055-.139.055-.349z",
    transform: "rotate(-31.592 -154.394 178.15)",
    "aria-label": "R",
    style: {
      fontSize: "5.1299px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.418901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.83 128.74H91.3l-.365-1.04h-1.614l-.365 1.04h-.504l1.358-3.73h.661zm-1.047-1.466-.654-1.831-.656 1.83z",
    transform: "rotate(-29.219 -162.608 195.67)",
    "aria-label": "A",
    style: {
      fontSize: "5.12986px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.418901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.382 125.403q0 .279-.105.491-.106.213-.284.351-.21.165-.463.236-.25.07-.639.07H95.57v-3.73h1.104q.409 0 .612.03.202.03.388.125.205.108.298.278.093.168.093.404 0 .265-.136.453-.135.185-.36.298v.02q.378.078.596.333.218.253.218.641zm-.834-1.68q0-.136-.045-.228-.046-.093-.146-.15-.117-.068-.285-.083-.168-.018-.416-.018h-.591v1.077h.641q.233 0 .37-.022.138-.025.256-.1.118-.075.166-.193.05-.12.05-.283zm.318 1.7q0-.225-.068-.358-.068-.132-.245-.225-.12-.063-.293-.08-.17-.02-.416-.02h-.78v1.387h.657q.326 0 .534-.032.207-.035.34-.125.14-.098.206-.223.065-.126.065-.324z",
    transform: "rotate(-27.84 -168.01 207.193)",
    "aria-label": "B",
    style: {
      fontSize: "5.1299px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.418901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.308 120.215h-2.457v-3.73h2.457v.441h-1.961v1.022h1.961v.441h-1.961v1.385h1.961zm-.47-5.132-.685.937h-.373l.448-.937z",
    transform: "rotate(-24.257 -184.86 243.134)",
    "aria-label": "\\xC9",
    style: {
      fontSize: "5.1299px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.418901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48 108.626h-.615l-1.768-3.337v3.337h-.463v-3.73h.769l1.613 3.046v-3.046h.463z",
    transform: "rotate(-18.535 -225.044 328.847)",
    "aria-label": "N",
    style: {
      fontSize: "5.1299px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.418901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.91 107.766q0 .218-.102.43-.1.214-.283.361-.2.16-.469.251-.265.09-.641.09-.403 0-.726-.075-.321-.075-.654-.223v-.621h.035q.283.235.654.363.37.128.696.128.46 0 .716-.173.258-.173.258-.46 0-.249-.122-.367-.12-.117-.369-.182-.187-.05-.408-.083-.218-.033-.463-.083-.496-.105-.737-.358-.238-.255-.238-.664 0-.468.396-.766.396-.3 1.005-.3.393 0 .72.074.33.075.582.186v.586h-.035q-.213-.18-.561-.298-.346-.12-.709-.12-.398 0-.641.165-.24.165-.24.426 0 .233.12.365.12.133.423.203.16.035.456.085.295.05.5.103.416.11.627.333.21.223.21.624z",
    transform: "rotate(-18.613 -224.327 327.318)",
    "aria-label": "S",
    style: {
      fontSize: "5.1299px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.418901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.142 89.021-.078 3.209h-.505l-.084-3.209zm-.03 4.428h-.607v-.627h.607z",
    transform: "rotate(-11.952 -318.328 527.824)",
    "aria-label": "!",
    style: {
      fontSize: "6.09036px",
      fontFamily: "Gaegu",
      InkscapeFontSpecification: "Gaegu-Regular",
      fill: "#fff",
      strokeWidth: 0.497331
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s.355-.206.483-.278v-.868C.431-8.917.696-15.368 1.37-22.69c.051-.575.175-1.867.175-1.867C3.081-40.068 5.887-50.406 14.56-50.464c2.531-.016 5.027-.024 7.493-.024 15.772 0 30.635.327 45.008.643 14.91.328 30.327.668 47.313.668 2.744 0 5.533-.009 8.439-.028 2.588 0 5.048 1.051 6.926 2.958 4.335 4.403 5.758 13.222 5.44 33.654-.033 3.482-.136 6.894-.256 10.844l-.099 3.266c-.056 1.968-.112 3.907-.158 5.793.263.202.516.413.759.635 2.786 2.537 4.187 5.639 5.096 8.057 2.861 7.61 3.148 15.305.852 22.872-.897 2.959-2.497 5.688-4.754 8.113-3.628 3.897-7.99 5.729-11.779 7.007-8.025 2.704-16.773 4.504-26.745 5.5-5.432.543-10.735.856-15.778.93.166 11.353.289 20.644.389 29.452.041 3.628-.86 6.446-2.676 8.456 1.116 1.314 2.063 2.964 2.604 5.059 2.364 9.151 1.079 18.663-3.819 28.269-1.716 3.369-5.064 5.462-8.736 5.462-4.276 0-7.991-2.82-9.246-7.016l-.343-1.144c-1.48-4.926-3.011-10.02-3.529-15.483-.384-4.052.258-7.808 1.809-11.061l-.694-5.702a54.503 54.503 0 0 0-.182-1.295c-.181-1.207-.385-2.575-.413-4.091-.057-3.225-.066-6.478-.075-9.623l-.002-.557s-.009-3.181-.017-4.287l-.054-4.315-.168-12.565a432.717 432.717 0 0 1-6.818-.376c-2.784-.169-5.661-.343-8.45-.44-9.314-.322-17.56-1.171-25.21-2.594-1.195-.223-2.324-.486-3.416-.74-1.473-.343-2.866-.667-4.125-.816-3.985-.473-7.403-2.381-10.157-5.671-3.465-4.137-5.029-8.816-6.203-13.255-1.293-4.887-1.552-9.794-1.76-13.736-.211-4.003.207-7.915 1.245-11.627C-7.211 8.872-5.632 3.225 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 30.53 24.484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.634.118-3.249.499-5.679.891-.191-1.573-.516-3.117-.544-4.665-.09-5.125-.046-10.252-.103-15.378-.131-11.574-.347-23.145-.407-34.719-.021-3.862 1.821-5.22 5.573-4.541 3.38.611 4.502 1.676 5.11 5.075.258 1.436.427 2.905.449 4.363.229 14.65.439 29.3.604 43.95C5.046-1.247 3.947-.285 0 0",
    style: {
      fill: "#feecb9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 36.143 16.943)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.5-5.017-3.12-10.115-3.61-15.282-.48-5.062 1.241-9.814 6.131-12.679 2.713.942 5.049 2.113 5.795 5.002 2.123 8.218.478 15.974-3.278 23.34C3.843 2.728.752 2.516 0 0",
    style: {
      fill: "#feaf2f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 35.892 14.313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.096-2.771-6.964-5.817-11.189-8.184-.009-1.071-.028-2.143-.034-3.215a8.879 8.879 0 0 1 .111-1.466C-7.05-10.841-3.29-8.202-.077-5.582-.048-3.721-.028-1.86 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 36.5 20.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c4.21 2.216 8.068 5.051 11.288 7.782l.015 1.047c.02 1.817-.235 2.97-.932 3.722C7.498 9.963 3.938 7.12.033 4.802.025 3.201.005 1.601 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 35.643 18.043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.024 1.883.054 3.766.077 5.649-3.043-2.796-6.943-5.966-11.25-8.481-.019-1.601-.042-3.201-.063-4.801C-7.065-5.479-3.227-2.703 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 36.525 18.506)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.166-2.759-7.043-5.697-11.234-7.924-.022-1.562-.03-3.126-.049-4.688C-7.188-10.7-3.369-8.127-.076-5.517-.049-3.678-.026-1.839 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 36.515 19.229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.003 4.902 1.58 13.699-2.365 16.566-36.359 7.432-73.928 6.317-110.642 2.243-9.882-2.876-9.548-86.818-.185-86.88 37.869-.252 67.79 1.528 108.189 1.258C4.265-66.874-1.479-19.271 0 0",
    style: {
      fill: "#feecb9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 40.677 22.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.612 2.019-1.695 3.782-3.18 5.376-2.467 2.652-5.62 4.04-8.891 5.143-8.18 2.757-16.639 4.313-25.205 5.169-5.29.528-10.62.852-15.934.905-7.236.072-14.478-.12-21.713-.355-5.874-.191-11.738-.704-17.612-.907-8.118-.282-16.184-.995-24.171-2.481-2.676-.498-5.306-1.307-7.998-1.626-2.422-.287-4.135-1.445-5.615-3.213-2.577-3.076-3.803-6.774-4.802-10.552-1.066-4.027-1.318-8.17-1.537-12.313-.168-3.183.137-6.305.995-9.375.751-2.686 1.931-5.085 4.468-6.538.577-.331 1.249-.762 1.855-.729 2.705.146 5.298.73 7.016 3.101 1.922 2.653 3.869 5.296 5.623 8.059 1.924 3.028 3.609 6.208 5.467 9.279.587.971 1.392 1.809 2.098 2.708l.428-.171c.03-1.151.097-2.302.083-3.453-.022-1.857-.17-3.715-.135-5.569.068-3.495.823-6.842 2.078-10.123 1.375-3.592 6.403-4.42 8.932-2.122.996.904 1.884 1.97 2.637 3.087.93 1.382 1.671 2.892 2.491 4.349 2.246 3.991 4.481 7.989 6.745 11.971.63 1.107 1.284 1.149 1.842-.01.581-1.207 1.036-2.527 1.256-3.846.459-2.744.689-5.526 1.083-8.283.343-2.401.897-4.768 2.379-6.755.49-.659 1.23-1.472 1.94-1.563 2.271-.291 4.532.023 5.998 2.066 1.328 1.85 2.601 3.768 3.649 5.786 1.422 2.743 2.556 5.634 3.911 8.416 1.075 2.21 2.367 4.301 4.209 6.616.088-1.2.21-1.971.188-2.738-.101-3.49.241-6.941 1.081-10.316.414-1.66 1.025-3.319 1.847-4.812.449-.817 1.462-1.697 2.333-1.834 2.103-.333 4.211-.069 5.655 1.878.442.595.964 1.138 1.342 1.769a342.095 342.095 0 0 1 4.108 7.059c.713 1.261 1.339 2.571 2.049 3.945.682-3.316 1.287-6.461 1.985-9.586.563-2.53 1.766-4.728 3.705-6.498.875-.799 1.838-1.109 3.045-.983 2.289.238 4.065 1.261 5.537 3.016 2.325 2.775 4.198 5.815 5.682 9.107.579 1.285 1.17 2.564 1.906 4.171.705-1.76 1.176-3.173 1.825-4.5 1.395-2.854 3.005-5.471 6.306-6.612 2.29-.792 5.296-.434 7.053 1.166 1.615 1.471 2.52 3.384 3.257 5.346C1.562-12.344 1.878-6.19 0 0",
    style: {
      fill: "#ff8e75",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 41.223 21.559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 119.602 3.275c.216 7.612-.034 13.376-.283 21.963l-120.34-2.291C-1.092 14.127-.742 7.522 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.0794 0 0 -.0794 31.204 26.375)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdaySign);
export default __webpack_public_path__ + "static/media/birthday_sign.cab69dc82d81c22821bde07da63c399e.svg";
export { ForwardRef as ReactComponent };